import { createTranslationStore } from "./translationStore";
import { getReadScope } from "./readCache";
export const automaticTranslation = createTranslationStore({
  scope: getReadScope,
  enabled: () => process.env.REACT_APP_AUTOMATIC_TRANSLATION === "true" && Boolean(localStorage.getItem("userToken")),
  transport: async body => {
    const { axiosInstance } = await import("../api/config/configApi");
    const response = await axiosInstance.post("/client/localization/translate", body, { timeout: 5000 });
    return response.data?.Data || response.data;
  }
});
